import { render, staticRenderFns } from "./cardPackage.vue?vue&type=template&id=5f16fef0&scoped=true&"
import script from "./cardPackage.vue?vue&type=script&lang=js&"
export * from "./cardPackage.vue?vue&type=script&lang=js&"
import style0 from "./cardPackage.vue?vue&type=style&index=0&id=5f16fef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16fef0",
  null
  
)

export default component.exports